import React from 'react';
import { useTranslation } from '@wix/yoshi-flow-editor';
import { useSelector } from '../../../common/components/runtime-context';
import { getCategoryMenuWidgetData } from '../../aggregated-category-menu/selectors';
import LinkList from '../link-list';
import LinkText from '../link-text';

const CategoryMenu = () => {
  const { t } = useTranslation();
  const categoryMenuWidgetData = useSelector(getCategoryMenuWidgetData);
  const links = React.useMemo(
    () =>
      categoryMenuWidgetData.categoryMenu.map((category) => ({
        key: category.id,
        path: category.path,
        text: (
          <LinkText
            postCount={t('category-link.post-count', {
              count: category.postCount,
            })}
            a11yText={t('category-link.a11y-post-count', {
              count: category.postCount,
            })}
          >
            {category.label}
          </LinkText>
        ),
      })),
    [categoryMenuWidgetData, t],
  );

  return (
    <nav aria-label={t('aria-label.category-menu')}>
      <LinkList links={links} emptyState={{ text: t('empty-state.no-categories') }} />
    </nav>
  );
};

export default CategoryMenu;
